<template>

  <div >
    <br>

  <template  v-if='xuanran'>
  
    <div
    :style="'background-color:'+globalsetting.fbcolor" 
    style="display: flex;flex-direction: column;align-items: center;
    background-color: white;margin: 10px;
    padding: 5px;
    border-radius: 5px;
    ">
    <div style="width: 80%;background-color: blue;
     background-image: linear-gradient(to right, rgb(135, 135, 194) 30%, blue);
    height: 40px;border-radius:5px;
    color: white;font-size: 25px;text-align: center;
    position: relative;top: -12px;
    ">
    {{xuanran.maintitle?xuanran.maintitle:'感谢参与'}}
  
    </div>
      <div class="stitle" style="font-size: 30px;"  v-html="xuanran.stitle"></div>
      <br>
      <div class="sstitle" v-html="xuanran.sstitle"></div>
      <br>
      <div class="spic" style=" display: flex;justify-content:space-around;">
        <div v-for="(v,k) in xuanran.spic" style="width: 30%;">
          <img  style="width: 100%;" :src="v.pic" alt="">
          <div style="text-align: center;">
            {{v.text}}
          </div>  
        </div>
       
  
      </div>
  <br>
      <div class="btext" style="font-size: 20px;text-align: center;" v-html="xuanran.btext"></div>
     <br> 
      <div class="sbtext"  v-html="xuanran.sbtext"></div>
   <br>
    </div>
  </template>
  
  <div v-else-if="erweima"  style="display: flex;flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;margin: 10px;
  padding: 5px;
  border-radius: 5px;
  min-height: 60vh;
  user-select: text;
  color: #949393;
  "
  :style="'background-color:'+(globalsetting.fbcolor?globalsetting.fbcolor:'white')" 
  
  >
 
    <!-- <img src="https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=2328003967,2854654650&fm=26&gp=0.jpg"
    style="width: 60%;"> -->
    <div ref="qrCodeUrl"></div>
    <br>
  长按二维码保存


  </div>
  
  
    <div v-else   style="display: flex;flex-direction: column;align-items: center;
    background-color: white;margin: 10px;
    padding: 5px;
    border-radius: 5px;
    min-height: 60vh;
    "
    :style="'background-color:'+globalsetting.fbcolor" 
    >
      <br>
      <br>
      <br>
    <div class=" v-center">
        <div>
      <i class="weui-icon_msg weui-icon-success-no-circle"></i>
      </div>
        <div class="f40">提交成功</div>
    </div>
      <div class=" v-center">
    <br>
    <br>
    <br>
    <br>
        <div>感谢您的参与！</div>
    </div>
    </div>
  
    
  
  </div>
  
  
  
  </template>
  
  <script>
      import QRCode from 'qrcodejs2'
    export default {
      name: 'Success',
      props:['globalsetting','tb',"erweimasign"],
      data(){
        return{
          xuanran:'',
          erweima:"",
        }
      },
      created(){
        if(this.tb){
            this.xuanran = this.tb;
  }else{
    this.xuanran = "";
  }
        if(this.erweimasign){
          this.erweima = this.erweimasign;
        }

      },
      mounted(){
        if(this.erweima){
          this.cerweima(this.erweima)
        }
        
      },
      watch:{
        tb(){
    
          if(this.tb){
            this.xuanran = this.tb;
  }else{
    this.xuanran = "";
  }
        }
      },
      methods:{
        
      cerweima(rm) {
        var qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: rm, // 需要转换为二维码的内容
          width: 160,
          height: 160,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      },
      }
      }
  
  </script>
  
  <style>
  
  </style>
  


// WEBPACK FOOTER //
// src/fields/Success.vue